import {
  ChangeDetectorRef, Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef
} from '@angular/core';
import { Subscription } from 'rxjs';
import { EntitlementsService } from '../../../core/service/entitlements.service';

/**
 * SD-1218: structural directive for ad-hoc entitlement checks outside the sidemenu.
 *
 *     <button *appHasModule="'agents'">Ask an agent</button>
 *
 * Re-evaluates when entitlements change, so a revoked module disappears without a reload.
 */
@Directive({ selector: '[appHasModule]' })
export class HasModuleDirective implements OnInit, OnDestroy {

  @Input('appHasModule') appHasModule: string;

  private subscription: Subscription;
  private rendered = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private entitlements: EntitlementsService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (!this.appHasModule) {
      // No code given: render rather than hide. A typo in a template should not silently
      // remove a control.
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.rendered = true;
      return;
    }

    this.subscription = this.entitlements.has$(this.appHasModule).subscribe(allowed => {
      if (allowed && !this.rendered) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.rendered = true;
      } else if (!allowed && this.rendered) {
        this.viewContainer.clear();
        this.rendered = false;
      }
      this.changeDetector.markForCheck();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
